// Product brief for OneAmerica Asset Care. See cmTwo.ts for the format intent.

export const oaAssetCareBrief = `**OneAmerica Asset Care** — hybrid whole life with AOB/COB LTC riders.

Pool model — two pools, drawn in order:
- **Acceleration of Benefits (AOB)** is the \`base_pool\`, drawn FIRST.
- **Continuation of Benefits (COB)** is the \`eob\` column, drawn only after AOB
  is exhausted.
- Each pool inflates independently and compounds at the policy anniversary on
  its own rate (\`base_pool_inflation\` / \`eob_pool_inflation\` in the header). So
  the two pool ceilings can grow at different rates, and the COB monthly cap can
  diverge from the AOB monthly cap once AOB is gone.
- The monthly benefit cap follows the active pool: AOB rows use the AOB cap/rate;
  once AOB is exhausted, COB reimbursements use the COB cap/rate.

Payout model — reimbursement OR cash indemnity:
- **Reimbursement** (default): pays min(eligible cost, pro-rated cap), drawing
  AOB then COB. Care cost above the cap is out-of-pocket.
- **Indemnity** (AOB-only election): pays cap × indemnity% × (eligible days / 30)
  as cash regardless of actual cost, from AOB (75% on mapped Asset Care
  illustrations via \`policyIndemnityBenefitPercent\`; a missing or non-positive
  percent defaults to the product's fixed 75% cap — P2-10). Once AOB exhausts,
  the strategy falls back to reimbursement on COB — indemnity is unavailable on
  COB. The fall-back is day-granular (P2-9): in the AOB-exhausting month the
  AOB pays its cash sliver and the remaining eligible days reimburse from COB
  in the same row.

Death benefit:
- Flat Face Amount, depleted **dollar-for-dollar by AOB drawdown only**. COB
  drawdown does NOT reduce the death benefit. Remaining DB at the horizon is a
  non-LTC return.

Elimination period:
- **No retroactive WP lump.** Elimination-period days are fully out-of-pocket
  (\`in-wp\` rows). Joint policies serve a separate EP per spouse.

Things to eyeball:
- AOB depletes before any COB drawdown — \`eob\` stays flat until \`base_pool\` hits 0.
- COB payouts use the COB monthly cap when the AOB and COB rates differ.
- Death benefit falls in step with AOB drawdown, not COB.
- No EP reimbursement lump anywhere.
`;
